import React from "react";
import {PdfElementProps} from "./_models";
import {
    Image,
    StyleSheet,
} from "@react-pdf/renderer";

export function PdfImageComponent({config}: PdfElementProps) {
    const style = StyleSheet.create({
        main: {
            ...{
                width: '100%'
            },
            ...(config.style || {}),
        }
    })

    return (
        <Image style={style.main} src={config.content}/>
    )
}